/* eslint-disable @typescript-eslint/indent */
/* eslint-disable no-unsafe-optional-chaining */
import { Container, Typography } from '@pwskills/rachnaui';
import React, { useContext } from 'react';
import CourseDescriptionContext from '@/context/CourseDescriptionContext';
import CheckMarkIcon from '@/assets/icons/CheckMarkIcon';
import { useRouter } from 'next/router';
// import { COURSE_PURCHASE_TYPE } from '@/utils/common/common.constants';
import { COURSE_PURCHASE_TYPE } from '@/utils/common/common.constants';
import Headers from '../../Header';
import ProfessionalThemeHeader from '../../Header/ProfessionalThemeHeader';
import { handleCourseExpiryLogic } from './utils';
// import { handleCourseExpiryLogic } from './utils';

const ProgramOutcomes = ({ isArmature = true }: { isArmature?: boolean }) => {
  const { courseDetails } = useContext(CourseDescriptionContext);
  const { statsInfo } = courseDetails?.courseMetaDetails || {};
  const { careerTransitions, highestSalary, hiringPartner } = statsInfo || {};
  const router = useRouter();
  const isDashboard = router.pathname.includes('/dashboard');
  const outcomeIcons = {
    hiringPartnersIcon: '/images/courseDescription/hiringPartnerIcon.svg',
    careerTransitionIcon: '/images/courseDescription/careerTransitionIcon.svg',
    highestSalaryIcon: '/images/courseDescription/highestSalaryIcon.svg',
  };

  if (!courseDetails?.courseMetaDetails?.outcomes) {
    return null;
  }

  const programOutcome = [
    { title: 'Hiring partners', description: hiringPartner, icon: outcomeIcons.hiringPartnersIcon },
    {
      title: 'Career Transitions',
      description: careerTransitions,
      icon: outcomeIcons.careerTransitionIcon,
    },
    { title: 'Highest Package', description: highestSalary, icon: outcomeIcons.highestSalaryIcon },
  ];
  const returnChildren = () => {
    const coursePointers = [
      ...(courseDetails?.config?.isCourseExpiryEnabled &&
      courseDetails?.coursePurchaseType === COURSE_PURCHASE_TYPE.INDIVIDUAL
        ? [
            {
              title: 'Content Access',
              subText: `Access to recorded content for ${handleCourseExpiryLogic(
                courseDetails
              )} months.`,
              _id: '1',
            },
          ]
        : !courseDetails?.config?.isCourseExpiryEnabled &&
          courseDetails?.coursePurchaseType === COURSE_PURCHASE_TYPE.INDIVIDUAL
        ? []
        : []),
      ...(courseDetails?.courseMetaDetails?.about?.coursePointers || []),
    ];

    return (
      <div className="flex flex-col gap-14" id="overview">
        {isArmature && (
          <header className={isDashboard ? 'flex' : 'flex justify-center text-[#3D3D3D]'}>
            {isDashboard ? (
              <Typography component="subheading" variant="bold" className="text-gray-850">
                {`About ${courseDetails.batchName}`}
              </Typography>
            ) : (
              <Headers
                title={`About ${courseDetails.batchName}`}
                classes="flex w-full !min-w-full justify-center text-gray-850 medium:w-auto medium:!text-center !self-center !w-[50%] medium:!w-full !line-clamp-2 regular:!text-center"
              />
            )}
          </header>
        )}
        <div className="flex w-full  justify-between items-center">
          <div className="flex flex-col w-full gap-6 large:!w-[628px]">
            <div className="flex flex-col gap-3 medium:gap-6">
              {!isArmature && isDashboard && (
                <Typography
                  component="h4"
                  variant="semi-bold"
                  className="line-clamp-2"
                >{`About ${courseDetails.batchName}`}</Typography>
              )}
              {!isArmature && !isDashboard && (
                <ProfessionalThemeHeader
                  title={`About ${courseDetails.batchName}`}
                  headingClass="!line-clamp-2"
                />
              )}

              <Typography
                component="body-small"
                variant="regular"
                className={isDashboard ? 'text-gray-650' : 'text-gray-650 !text-[16px]'}
              >
                {courseDetails.courseMetaDetails?.about?.description}
              </Typography>
            </div>
            <div className="flex flex-col medium:!flex-row justify-between  medium:!items-center medium:!gap-x-[50px] large:!gap-x-0 gap-y-6 medium:!gap-y-0">
              <div
                className={
                  isDashboard
                    ? 'grid grid-cols-1 regular:grid-cols-2 gap-4'
                    : 'flex flex-col large:!flex-row flex-wrap large:!gap-x-6 medium:flex-1 gap-y-6  large:!gap-y-4'
                }
              >
                {coursePointers.map((pointer) => {
                  return (
                    <div
                      className="flex flex-col pr-4 py-2 gap-2 w-full large:!w-[302px]"
                      key={pointer._id}
                    >
                      <div className="flex gap-2 items-center">
                        <CheckMarkIcon
                          width={isDashboard ? '16.67' : '24'}
                          height={isDashboard ? '16.67' : '25'}
                        />
                        <Typography
                          variant="bold"
                          component={isDashboard ? 'body-small' : 'body-regular'}
                          className={isDashboard ? 'text-gray-850' : ''}
                        >
                          {pointer.title}
                        </Typography>
                      </div>
                      <Typography
                        variant="regular"
                        component="body-small"
                        className="text-[#757575]"
                      >
                        {pointer.subText}
                      </Typography>
                    </div>
                  );
                })}
              </div>

              <div className="relative !h-full !w-full  medium:!w-[328px] medium:!h-auto large:!hidden !block self-center">
                {courseDetails?.courseMetaDetails?.about?.thumbnailUrl && (
                  <img
                    alt={courseDetails.courseMetaDetails?.about?.altText}
                    src={courseDetails?.courseMetaDetails?.about?.thumbnailUrl}
                    width={320}
                    height={320}
                    className="!h-full !w-full  medium:!w-[328px] medium:!h-auto large:!w-[526px] large:!h-auto large:!hidden !block self-center rounded-xl"
                  />
                )}
              </div>
            </div>
          </div>
          {/* hidden in small and medium device */}

          <div
            className={
              isDashboard
                ? 'relative w-full hidden  medium:!h-auto large:!w-1/3  large:!block '
                : 'relative  medium:!w-[328px] medium:!h-auto large:!w-[526px] hidden large:!block '
            }
          >
            {courseDetails?.courseMetaDetails?.about?.thumbnailUrl && (
              <img
                alt="alt text"
                src={courseDetails?.courseMetaDetails?.about?.thumbnailUrl}
                width={526}
                height={372}
                className="!w-full !h-full medium:!w-[328px] medium:!h-auto large:!w-[526px]   hidden large:!block rounded-xl"
              />
            )}
          </div>
        </div>

        {courseDetails?.courseMetaDetails?.enablePlacementStats && !isDashboard && (
          <div className="flex gap-6  medium:gap-4 large:gap-6 flex-wrap justify-center">
            {programOutcome?.map((outcome) => {
              return (
                outcome.description && (
                  <div className="bg-blue-50 rounded !w-full medium:!w-[332px]  large:!w-[410px]  h-[142px] py-3 flex flex-col gap-1 justify-center items-center border border-[#F8F8F8]">
                    <img width={62} height={62} src={outcome?.icon} alt={outcome.title} />
                    <Typography variant="semi-bold" component="subheading">
                      {outcome.description}
                    </Typography>
                    <Typography variant="regular" component="body-small" className="text-gray-650">
                      {outcome.title}
                    </Typography>
                  </div>
                )
              );
            })}
          </div>
        )}
      </div>
    );
  };

  return (
    <section className="py-8 medium:py-14 large:pt-14 large:pb-[48px] max-w-full" id="overview">
      {isDashboard ? (
        <div className="py-4">{returnChildren()}</div>
      ) : (
        <Container className="medium:!px-8 large:!px-20">{returnChildren()}</Container>
      )}
    </section>
  );
};

export default ProgramOutcomes;
